import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksBrigades(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADES,
		options
	)
}
function _getDoneWorksBrigadePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_PREVIEW,
		options
	)
}
function _getDoneWorksBrigadePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_POPUP,
		options
	)
}

function _createDoneWorksBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].CREATE_DONE_WORKS_BRIGADE,
		options
	)
}

function _getDoneWorksBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE,
		options
	)
}

function _patchDoneWorksBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PATCH_DONE_WORKS_BRIGADE,
		options
	)
}

function _putDoneWorksBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PUT_DONE_WORKS_BRIGADE,
		options
	)
}

function _deleteDoneWorksBrigade(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].DELETE_DONE_WORKS_BRIGADE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADES]: _getDoneWorksBrigades,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_PREVIEW]: _getDoneWorksBrigadePreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE_POPUP]: _getDoneWorksBrigadePopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].CREATE_DONE_WORKS_BRIGADE]: _createDoneWorksBrigade,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].GET_DONE_WORKS_BRIGADE]: _getDoneWorksBrigade,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PATCH_DONE_WORKS_BRIGADE]: _patchDoneWorksBrigade,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].PUT_DONE_WORKS_BRIGADE]: _putDoneWorksBrigade,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_BRIGADE].DELETE_DONE_WORKS_BRIGADE]: _deleteDoneWorksBrigade,
}